import { render, staticRenderFns } from "./CartSmall.vue?vue&type=template&id=0a29d93e&"
import script from "./CartSmall.vue?vue&type=script&lang=js&"
export * from "./CartSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports